import { Tooltip } from '@mui/material';

export function BackForeColor({
  backColor,
  foreColor,
  styleName,
  text,
  TooltipText,
}) {
  const renderComponent = () => (
    <p
      className={`rounded p-2 default_operational_status ${styleName}`}
      style={{
        background: backColor,
        color: foreColor,
        borderRadius: '40px',
        textAlign: 'center'
      }}
    >
      {text}
    </p>
  );

  return (
    <div>
      {TooltipText ? (
        <Tooltip title={TooltipText}>{renderComponent()}</Tooltip>
      ) : (
        renderComponent()
      )}
    </div>
  );
}
